<template>
  <div>
    <EditForm
      ref="editForm"
      :billNo="devTrackingQuotationNo"
      :tskInfoNo="tskInfoNo"
      :disabled="disabled"
    />
    <div class="d-flex justify-content-end mt-2">
      <el-button type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import EditForm from '../components/edit-form'
export default {
  components: { EditForm },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    query() {
      return this.$route.query
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    devTrackingQuotationNo() {
      return this.params.devTrackingQuotationNo
    },
    tskInfoNo() {
      return this.query.tskInfoNo
    },
  },
  methods: {
    async save() {
      const result = await this.$refs.editForm.save()
      if (!result) return

      if (!this.devTrackingQuotationNo) {
        const { devTrackingQuotationNo } = result
        this.$router.replace({
          name: 'customerManage-selectionQuotation-detail',
          params: { devTrackingQuotationNo, pageType: 'edit' },
        })
        return
      }

      this.$refs.editForm.reload()
    },
  },
}
</script>

<style scoped></style>
